import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    visible: false,
    color: 'green',
    message: ''
  },
  mutations: {
    hideSnackbar(state) {
      state.visible = false
    },
    showSnackbar(state, message) {
      state.message = message
      state.visible = true
      state.color = 'green'
    },
    showErrorSnackbar(state, message) {
      state.message = message
      state.visible = true
      state.color = 'error'
    }
  },
  getters: {
    isVisible: state => state.visible,
    message: state => state.message,
    color: state => state.color
  }
}
